<!-- 右键组件
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-06-01 16:29:00
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-06-02 15:11:25
-->
<template>
  <div
    :class="setClass()"
    v-show="contextMenu"
    @click="contextMenu = false"
    :style="styleName"
  >
    <div
      :class="setClass('item')"
      @click="onWidgetCancel"
    >
      <i class="el-icon-close"></i>取消
    </div>
    <div
      :class="setClass('item')"
      @click="onWidgetDelete"
    >
      <i class="el-icon-delete"></i>删除组件
    </div>
    <div
      :class="setClass('item')"
      @click="onWidgetClone"
    >
      <i class="el-icon-document"></i>复制组件
    </div>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { deepClone, createId, setPx } from '@/dragComponents/utils'
export default {
  name: 'context-menu',
  mixins: [bem],
  props: ['data', 'select'],
  data() {
    return {
      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
    }
  },
  computed: {
    styleName() {
      return {
        left: setPx(this.contextMenuX + 120),
        top: setPx(this.contextMenuY),
      }
    },
  },
  methods: {
    show(X = 0, Y = 0) {
      this.contextMenuX = X
      this.contextMenuY = Y
      this.contextMenu = true
    },
    hide() {
      this.contextMenuX = 0
      this.contextMenuY = 0
      this.contextMenu = false
    },
    onWidgetCancel() {
      this.$emit('change')
    },
    onWidgetDelete() {
      this.$confirm(`是否删除所选组件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let list = this.data.list.filter((item) => {
            return item !== this.select
          })
          this.$set(this.data, 'list', list)
          this.$emit('change')
        })
        .catch(() => {})
    },
    onWidgetClone() {
      let item = deepClone(this.select)
      let index = this.data.list.length
      item.prop = createId(item.type)
      item.index = index + 1
      this.data.list.push(item)
      this.$emit('change')
    },
  },
}
</script>
<style lang="scss" scoped>
.context-menu {
  position: fixed;
  z-index: 99999;
  width: 120px;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 0;
  background: #fff;
  color: #333;

  &-item {
    z-index: 10000;
    padding: 8px 12px;
    cursor: pointer;
    position: relative;
    font-size: 12px;

    &:hover {
      background-color: rgba(0, 192, 222, 0.1);
    }

    & i {
      margin-right: 5px;
    }

    & :first-child {
      padding-top: 5px;
    }
  }
}
</style>
